import { useMemo } from 'react';

import { useWizardActiveStep } from '../../wizard/resources/hooks/useWizardActiveStep';
import { stepperSteps, wizardStepToStepperStepMap } from '../constants';
import { useLastFilledStep } from './useLastFilledStep';

export const useActiveStepperStep = () => {
    const activeWizardStep = useWizardActiveStep();
    const { lastFilledStep } = useLastFilledStep();

    return useMemo(() => {
        const step = activeWizardStep ?? lastFilledStep;
        const stepperStep = wizardStepToStepperStepMap[step];

        return stepperSteps.indexOf(stepperStep);
    }, [activeWizardStep, lastFilledStep]);
};
